import { render, staticRenderFns } from "./LoanPortfolioSummary.vue?vue&type=template&id=ff3ef734&"
import script from "./LoanPortfolioSummary.vue?vue&type=script&lang=js&"
export * from "./LoanPortfolioSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports